import { useEffect, useMemo } from 'react';
import { applyTerminologyOverlays, TERMINOLOGY_OVERLAYS, useLocale } from '@zagru/platform';
import { isEnabled, useEnablement } from '@/api/enablement';

/**
 * W2 (spec §4.4): lays the terminology overlay of every enabled pack or app over the catalogue — "HS code" reads
 * "GTİP" while `tr.customs` is installed — for the language in use, its fallback and English.
 *
 * An overlay's owner is enabled when it is installed as a pack or as an app (the contract lists pack apps under both).
 * Unlike the surfaces, the overlays do not fail open: until enablement is read, or when the read fails, the base
 * catalogue's neutral wording stands, which is correct for every tenant.
 */
export function I18nOverlayBridge(): null {
  const { data } = useEnablement();
  const { locale, fallbackLocale } = useLocale();
  const active = useMemo(() => (data ? TERMINOLOGY_OVERLAYS.filter((id) => isEnabled(data, { requiresAny: [`pack:${id}`, `app:${id}`] })) : []).join(','), [data]);
  useEffect(() => {
    void applyTerminologyOverlays(active ? active.split(',') : [], [locale, 'en', ...(fallbackLocale ? [fallbackLocale] : [])]);
  }, [active, locale, fallbackLocale]);
  return null;
}
